import React from 'react';
import Select from 'react-select';
import { Alert, Tooltip } from 'reactstrap';
import Swal from 'sweetalert2';
import { FaInfoCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';

import * as OpcionesList from '../../opciones.js';
import '../../assets/css/formulario.css';
import FechaExped from '../../assets/img/cedula_posterior.jpeg';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

export class VerificacionCedulaMini extends React.Component {

    abortController = new window.AbortController();

	constructor(props) {
		super(props);

		this.state = {
			identificacion: "", dia: "", mes: "", anio: "", idpersona: 0,
			cargandoValidAlert: false, cedulaAlert: false, mensajeAlerta: "",
			canLogin: false, cedTooltip: false
        }

        // METODOS
        this.showHideTooltip = this.showHideTooltip.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.exceptionsInput = this.exceptionsInput.bind(this);
        this.getDatosAlumni = this.getDatosAlumni.bind(this);
        this.closeAlert = this.closeAlert.bind(this);
	}

    showHideTooltip() {
        this.setState({ cedTooltip: !this.state.cedTooltip });
    }

    handleChange(event) {
        if (event.target.name === "identificacion") {
            this.setState({ identificacion: event.target.value });

        }
        else if (event.target.name === "anioIden") {
            var valorA = event.target.value;
            if (event.target.value.length > 4) { valorA = event.target.value.slice(0, 4); }
            this.setState({ anio: valorA });
        }
    }

    handleSelectChange(selectedOption, selName) {
        if (selectedOption !== null) {
            if (selName.name === "diaIden") {
                this.setState({ dia: selectedOption.value });
            }
            else if (selName.name === "mesIden") {
                this.setState({ mes: selectedOption.value });
            }
        }
    }

    exceptionsInput(event) {
        var validNum;
        if (event.key !== undefined) {
            validNum = event.key === "e" || event.key === "E" || event.key === "." || event.key === "+" || event.key === "-" || event.key === ",";
        } else if (event.keyCode !== undefined) {
            validNum = event.keyCode === 69 || event.keyCode === 190 || event.keyCode === 187 || event.keyCode === 189 || event.keyCode === 188;
        }

        return validNum && event.preventDefault();
    }

    getDatosAlumni() {
        Swal.fire({
            title: 'Buscando su información...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        var diaNa = Number(this.state.dia);
        var mesNa = Number(this.state.mes);
        var anioNa = Number(this.state.anio);

        if (this.state.identificacion === "" || this.state.dia === "" || this.state.mes === "" || this.state.anio === "") {
            var mensaje = "Llene todos los campos.";
            //this.setState({ cedulaAlert: true, mensajeAlerta: mensaje });
            Swal.fire({
                title: "¡Oh no!",
                text: 'Llene todos los campos.',
                icon: "error",
                timer: 5000,
                timerProgressBar: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false
            });

        } else if (diaNa < 1 || diaNa > 31 || mesNa < 1 || mesNa > 12) {
            //this.setState({ cedulaAlert: true, mensajeAlerta: mensaje });
            Swal.fire({
                title: '¡Oh no!',
                text: 'Fecha de nacimiento no coincide con los registros.',
                icon: 'error',
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.close();
                }
            });

        } else {
            //this.setState({ cargandoValidAlert: true, cedulaAlert: false });
            fetch("api/InformacionPostgrado/GetIdPersona/" + this.state.identificacion, { signal: this.abortController.signal })
                .then(response => response.json())
                .then(responsejson => {
                    if (responsejson["strEstado"] === "N") {
                        var mensaje = "No pertenece al grupo de alumni.";
                        Swal.fire({
                            title: '¡Oh no!',
                            text: 'No pertenece al grupo de alumni.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Swal.close();
                            }
                        });
                        //this.setState({ cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });

                    } else if (diaNa !== Number(responsejson.tdatosalumni.dia) || mesNa !== Number(responsejson.tdatosalumni.mes) || anioNa !== Number(responsejson.tdatosalumni.anio)) {
                        Swal.fire({
                            title: '¡Oh no!',
                            text: 'Fecha de nacimiento no coincide con los registros.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Swal.close();
                            }
                        });
                        //this.setState({ cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });

                    } else {
                        var idpersonaRJ = responsejson["tnumero"];
                        var datospostgrados = responsejson["tdatospostgrados"];
                        var datosalumni1 = responsejson["tdatosalumni"];

                        /*
                         * AQUI LLAMADA A LA FUNCION QUE ME HACE RETORNAR AL COMPONENTE PADRE
                         * ENVIAR COMO ARGUMENTOS IDPERSONA, DATOSPOSTGRADOS Y DATOSALUMNI
                         */
                        this.props.closeVerificacionCedulaMini(idpersonaRJ, datosalumni1, datospostgrados);
                    }
                }, error => {
                    if (error.name === "AbortError") {
                        console.log("AbortError controlado");
                    } else {
                        var mensaje = "Ocurrió un error al obtener la información.";
                        //this.setState({ cedulaAlert: true, mensajeAlerta: mensaje, cargandoValidAlert: false });
                        console.log("Ocurrió un error en InformacionPostgrado: " + error);

                        Swal.fire({
                            title: '¡Oh no!',
                            text: 'Ocurrió un error al obtener la información.',
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                Swal.close();
                            }
                        });
                    }
                });
        }
    }

    closeAlert(name) {
        if (name === "cedula") {
            this.setState({ cedulaAlert: false });
        }
    }

    render() {
        return (
            <>
                <div className="form-group row">
                    <div className="col-12 introduccion">
                        <p>Mantente conectado con Alumni ESPOL para que conozcas todos los eventos y beneficios que estamos preparando para ti.</p>
                    </div>
                    <div className="col-12 introduccion">
                        <p>¡Siempre en contacto, siempre juntos!</p>
                    </div>
                    <br />
                </div>
                <Alert isOpen={this.state.cargandoValidAlert} color="secondary"><div className="spinner-border text-secondary" role="status"><span className="visually-hidden"></span></div>&nbsp;Cargando</Alert>
                <Alert isOpen={this.state.cedulaAlert} color="danger" toggle={() => this.closeAlert("cedula")}>{this.state.mensajeAlerta}</Alert>
                <div className="form-group row">
                    <div className="col-md-3 col-12" style={{ textAlign: "center" }}>
                        <label className="control-label" style={{ fontSize: "unset", fontWeight: "bold" }} htmlFor="identificacion">Ingrese Identificaci&oacute;n:</label>
                    </div>
                    <div className="col-md-9" col-12>
                        <input className="form-control" type="number" name="identificacion" id="identificacion" onChange={this.handleChange} onKeyDown={this.exceptionsInput} />
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-md-3 col-12" style={{ textAlign: "center" }}>
                        <label className="control-label" style={{ fontSize: "unset", fontWeight: "bold" }}>Fecha de nacimiento:</label>
                    </div>
                    <div className="form-group row col-md-9 col-12" style={{ paddingRight: "0px", marginBottom: "0px" }}>
                        <div className="col-md-4 col-4" style={{ paddingRight: "0px" }}>
                            <input type="number" className="form-control" name="anioIden" id="anioIden" placeholder="aaaa" style={{ marginRight: "0px" }} value={this.state.anio} onChange={this.handleChange} onKeyDown={this.exceptionsInput} />
                        </div>
                        <div className="col-md-4 col-4" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                            <Select options={OpcionesList.MesesList} name="mesIden" id="mesIden" placeholder="mm" onChange={this.handleSelectChange} />
                        </div>
                        <div className="col-md-4 col-4" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
                            <Select options={OpcionesList.DiasList} name="diaIden" id="diaIden" placeholder="dd" onChange={this.handleSelectChange} />
                        </div>
                    </div>
                </div>
                <br />
                <div className="form-group row" style={{ textAlign: "center", marginBottom: "0px" }}>
                    <button type="button" style={{ margin: "auto", paddingBottom: "5px" }} className="btn info-button" onClick={this.getDatosAlumni}>Buscar</button>
                </div>
            </>
        );
    }
}

VerificacionCedulaMini.propTypes = {
    closeVerificacionCedulaMini: PropTypes.func
}

export default VerificacionCedulaMini;